import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class AgentPromptListService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getAgentPrompts(getParams) {
        const url = this.urlsService.AGENT.PROMPT_LIST_COLLECTION;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.ajaxService.getDataObserveBody(url, {
            ...getParams,
            tz,
        });
    }
    getAgentPrompt(agentPromptId) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.getDataObserveBody(url);
    }
    createAgentPrompt(body) {
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.AGENT.PROMPT_LIST_COLLECTION, body);
    }
    updateAgentPrompt(agentPromptId, body) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.putJsonDataObserveBody(url, body);
    }
    duplicateAgentPrompt(agentPromptId) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DUPLICATE, { agentPromptId });
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
}
AgentPromptListService.ɵfac = function AgentPromptListService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentPromptListService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AgentPromptListService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentPromptListService, factory: AgentPromptListService.ɵfac, providedIn: 'root' });
